import React, { useRef, useEffect } from 'react';
import { initializeDashboardEmbed, getDashboardEmbedURL } from 'util/dashboard';
import { API } from "aws-amplify";

export function DashboardsEmbedWrapper(props) {
  const quicksightRef = useRef();

  useEffect(() => {
    if (props.dashboardId) {
      async function init() {
        try {
          let url;
          if (props.dashboardId.includes('dash_query_vis_')) {
            const response = await API.get('DashboardApi', `/dashboard/${props.dashboardId}/view`);
            url = response.embedUrl;
          } else {
            url = await getDashboardEmbedURL(props.dashboardId);
          }
          quicksightRef.current = await initializeDashboardEmbed(url);
        } catch (err) {
          console.log('error getting dashboard embed url', err);
        }
      }
      init(props.dashboardId);
    }
  }, [props.dashboardId]);

  return (
    <div
      className="dashboard-graph-full"
      id="embeddingContainer"
      style={{ height: '750px' }}
    />
  );
}
